import { Action, createReducer, on } from '@ngrx/store';
import { InviteActions } from '../actions';
import { AcceptInvitationInput } from '@smash-sdk/iam/ejs/07-2021';

export const inviteFeatureKey = 'invite';

export interface State {
  errorMessage: any;
  inviteLoading: boolean;
  inviteSuccess: boolean;
  decodedMessage: AcceptInvitationInput;
  inviteTokenExpired: boolean;
  inviteTokenInvalid: boolean;
}

export const initialState: State = {
  errorMessage: null,
  inviteLoading: false,
  inviteSuccess: false,
  decodedMessage: null,
  inviteTokenExpired: false,
  inviteTokenInvalid: false,
};

const inviteReducer = createReducer(
  initialState,
  on(InviteActions.decodeMessageSuccess, (state, { decodedMessage }) => ({
    ...state,
    decodedMessage
  })),
  on(InviteActions.decodeMessageFailure, (state, { error }) => ({
    ...state,
    errorMessage: error,
    inviteTokenInvalid: true,
    inviteTokenExpired: false,
  })),

  on(InviteActions.acceptInvitation, (state) => ({
    ...state,
    inviteLoading: true
  })),
  on(InviteActions.acceptInvitationSuccess, (state, { }) => ({
    ...state,
    inviteLoading: false,
    inviteSuccess: true
  })),
  on(InviteActions.acceptInvitationFailure, (state, { error }) => ({
    ...state,
    errorMessage: error,
    inviteLoading: false,
    inviteSuccess: false
  })),
  on(InviteActions.inviteTokenExpired, (state, { error }) => ({
    ...state,
    inviteTokenExpired: true,
    inviteTokenInvalid: false,
    errorMessage: error,
    inviteLoading: false,
    inviteSuccess: false
  })),
);

export function reducer(state: State | undefined, action: Action) {
  return inviteReducer(state, action);
}
